<template>
  <component
    :is="tag"
    :type="type === 'button' || type === 'submit' ? type : ''"
    :class="classes"
    :href="to"
    :to="to"
    :disabled="disabled || loading"
    :style="styles"
    v-on="$listeners">
    <slot v-if="!loading" />
    <XSpinner
      v-else
      class="m-auto" />
  </component>
</template>

<script>
import ButtonMixin from '@common/components/mixins/ButtonMixin'

export default {
  mixins: [ButtonMixin],

  props: {
    color: {
      type: String,
      default: 'default'
    },
    active: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes () {
      let sizeClasses = !this.square ? [SIZES[this.size].join(' ')] : this.$style['square-button']

      return [...DEFAULT_BUTTON_CLASSES, sizeClasses, {
        [COLORS[this.color].active.join(' ')]: this.active,
        [COLORS[this.color].default.join(' ')]: !this.active,
        [COLORS[this.color].hover.join(' ')]: !this.loading && !this.disabled,
        'opacity-75 cursor-not-allowed': this.loading || this.disabled
      }]
    },

    styles () {
      return { width: this.width }
    }
  },

  mounted () {
    window.materialRipple(this.$el)
  }
}

const SIZES = {
  small: [
    'text-xs',
    'py-1',
    'px-2'
  ],
  medium: [
    'text-sm',
    'py-1',
    'px-3'
  ],
  normal: [
    'text-base',
    'py-2',
    'px-3'
  ],
  large: [
    'text-xl',
    'py-3',
    'px-6'
  ]
}
const DEFAULT_BUTTON_CLASSES = [
  'js-ripple',
  'relative',
  'overflow-hidden',
  'inline-block',
  'border-0',
  'focus:outline-none',
  'no-underline',
  'font-medium',
  'text-center'
]
const COLORS = {
  default: {
    default: [],
    hover: [],
    active: []
  },

  primary: {
    default: [
      'rounded',
      'text-white',
      'bg-info-50'
    ],
    hover: [
      'hover:bg-info-40',
      'hover:text-white'
    ],
    active: [
      'rounded',
      'text-white',
      'bg-info-40',
      'border-info-40'
    ]
  },

  secondary: {
    default: [
      'rounded',
      'text-white',
      'bg-info-50'
    ],
    hover: [
      'hover:bg-info-40',
      'hover:text-white'
    ],
    active: [
      'rounded',
      'bg-info-40',
      'text-white'
    ]
  },

  cancel: {
    default: [
      'rounded',
      'text-grey-50',
      'js-ripple-dark'
    ],
    hover: [
      'hover:text-grey-40'
    ],
    active: [
      'rounded',
      'text-grey-40',
      'js-ripple-dark'
    ]
  },

  warning: {
    default: [
      'rounded',
      'text-white',
      'bg-warning-50'
    ],
    hover: [
      'hover:bg-warning-40',
      'hover:text-white'
    ],
    active: [
      'rounded',
      'text-white',
      'bg-warning-40'
    ]
  },

  danger: {
    default: [
      'rounded',
      'text-white',
      'bg-danger-50'
    ],
    hover: [
      'hover:bg-danger-40',
      'hover:text-white'
    ],
    active: [
      'rounded',
      'text-white',
      'bg-danger-40'
    ]
  },

  timeline: {
    default: [
      'rounded-full',
      'text-white',
      'bg-info-50'
    ],
    hover: [
      'hover:bg-info-40',
      'hover:text-white'
    ],
    active: [
      'rounded-full',
      'text-white',
      'bg-info-40',
      'border-info-40'
    ]
  }
}
</script>

<style lang="scss" module>
.square-button {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
